import { render, staticRenderFns } from "./ListAreasTable.vue?vue&type=template&id=fe82d990&lang=pug"
import script from "./ListAreasTable.vue?vue&type=script&lang=js"
export * from "./ListAreasTable.vue?vue&type=script&lang=js"
import style0 from "./ListAreasTable.vue?vue&type=style&index=0&id=fe82d990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports